export default __webpack_public_path__ + "static/media/mastercard.abfe1e8b.svg";